import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { SettingsSidebar } from "@/components/settings/SettingsSidebar";
import { AccountSettings } from "@/components/settings/AccountSettings";
// TODO: uncomment to enable Brand Kit feature
// import { BrandKitSettings } from "@/components/settings/BrandKitSettings";
import { PlansUsageSettings } from "@/components/settings/PlansUsageSettings";
import { UsageHistorySettings } from "@/components/settings/UsageHistorySettings";
import { ProjectSettings } from "@/components/settings/ProjectSettings";

export function SettingsPage() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState(() => {
    if (searchParams.get("upgrade") === "1") return "plans-usage";
    return projectId ? "project-settings" : "account";
  });

  return (
    <SidebarProvider className="h-svh min-h-0! overflow-hidden">
      <SettingsSidebar
        projectId={projectId}
        activeSection={activeSection}
        onSectionChange={setActiveSection}
      />
      <SidebarInset className="max-h-svh overflow-auto bg-white dark:bg-[#1c1c1c]">
        {activeSection === "project-settings" && projectId && (
          <ProjectSettings projectId={projectId} />
        )}
        {activeSection === "account" && <AccountSettings />}
        {/* TODO: uncomment to enable Brand Kit feature */}
        {/* activeSection === "brand-kit" && <BrandKitSettings /> */}
        {activeSection === "plans-usage" && <PlansUsageSettings />}
        {activeSection === "usage-history" && <UsageHistorySettings />}
        {activeSection !== "account" &&
          activeSection !== "brand-kit" &&
          activeSection !== "plans-usage" &&
          activeSection !== "usage-history" &&
          activeSection !== "project-settings" && (
            <div className="flex h-full items-center justify-center">
              <p className="text-muted-foreground">Coming soon</p>
            </div>
          )}
      </SidebarInset>
    </SidebarProvider>
  );
}
